import { render, staticRenderFns } from "./StoryMore.vue?vue&type=template&id=3ff0455e&scoped=true"
import script from "./StoryMore.vue?vue&type=script&lang=js"
export * from "./StoryMore.vue?vue&type=script&lang=js"
import style0 from "./StoryMore.vue?vue&type=style&index=0&id=3ff0455e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0455e",
  null
  
)

export default component.exports